export const CN_MARKET = 'cn';
